import Constants from "../../config/Constants";
import axios from "axios";

export async function getProxyDomains(accessToken) {
    try {
        const url = Constants.APP_SERVER_OPTION_GET_PROXY_DOMAIN_URL;
        const response = await axios.get(url,
            {
                headers: {
                    'Content-Type': "application/json;charset=UTF-8",
                    Authorization: "Bearer " + accessToken,
                },
            });

        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw new Error('Failed to fetch. Please try again.');
    }
}







